// extracted by mini-css-extract-plugin
export default {"Tabs":"RoomTabsContainer_Tabs__UE69T","JoyTabs":"RoomTabsContainer_JoyTabs__F8v-w","TabPanel":"RoomTabsContainer_TabPanel__4HRmb","Tab":"RoomTabsContainer_Tab__Ri0CA"};